module.exports = __webpack_public_path__ + "static/proces budowy sieci stalych odbiorcow koncowych-7a5eff25d3fa9810ec75c6baf40c2d20.jpg";